import { clsx } from '@alexis/helpers/clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { getTranslationsState, getIsRtlState } from '@redux/selectors';

import styles from './FilterPopup.module.scss';

type FilterPopupProps = {
  top: number;
  offset: number;
  isFilterApplied?: boolean;
  onClearButtonClick?: () => void;
};

const FilterPopup: React.FC<FilterPopupProps> = ({
  top,
  offset,
  children,
  isFilterApplied,
  onClearButtonClick,
}) => {
  const isRtl = useSelector(getIsRtlState);

  const translations = useSelector(getTranslationsState);

  return (
    <div
      className={clsx(styles.dropdownContent)}
      style={isRtl ? { top, right: offset } : { top, left: offset }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.content}>{children}</div>

      {onClearButtonClick && (
        <div className={styles.clearButtonContainer}>
          <div
            className={clsx(styles.clearButton, !isFilterApplied && styles.disabled)}
            onClick={onClearButtonClick}
          >
            {translations.clear}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPopup;
